import { TimelineMax } from 'gsap';

export default (map, onStart) => {
    const timeline = new TimelineMax();

    const finalScale = 250 / window.innerWidth;
    timeline.fromTo(map, 2, {
        alpha: 0,
        mapScale: finalScale - 0.01,
    }, {
        alpha: 1,
        mapScale: finalScale,
        onStart: onStart || null,
    });

    timeline.finalScale = finalScale;

    return timeline;
};



// WEBPACK FOOTER //
// ./animations/mapFadeIn.js